import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FontColorsOutlinedSvg from "@ant-design/icons-svg/es/asn/FontColorsOutlined";
import AntdIcon from "../components/AntdIcon";
var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FontColorsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FontColorsOutlined.displayName = 'FontColorsOutlined';
}
export default /*#__PURE__*/React.forwardRef(FontColorsOutlined);